<template>
  <div id="ordering-bread" class="bread">
    <router-link class="bread-item" to="/">上上签</router-link>
    <div class="bread-arrow">&gt;</div>
    <router-link class="bread-item" to="/orders">我的订单</router-link>
    <div class="bread-arrow">&gt;</div>
    <a class="bread-item" v-if="orderStatus === 1">资料上传</a>
    <a class="bread-item" v-if="orderStatus === 2">填申请表</a>
    <a class="bread-item" v-if="orderStatus === 10">赴馆日期</a>
    <a class="bread-item" v-if="orderStatus === 0">修改商品</a>
    <a class="bread-item" v-if="orderStatus > 2 && orderStatus !== 10">确认订单</a>
  </div>
</template>

<script>
export default {
  name: 'ordering-bread',
  props: {
    orderStatus: {
      type: Number,
      required: true,
      default: 1,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/ordering/components/ordering-bread.vue